import { TestCategory } from '../../../../2_domain/test/test';
import LXSelector from './lxSelector';

interface LXTestCategorySelectorProps {
  value?: Category;
  onSelect: (category: Category) => void;
  width?: number;
  placeholder?: string;
}

const LXTestCategorySelector = (
  props: LXTestCategorySelectorProps & { testCategories: TestCategory[] }
) => {
  return (
    <LXSelector<Category>
      {...props}
      value={props.value}
      values={props.testCategories.map((val) => val.category)}
      labels={props.testCategories.map((val) => val.label)}
      onSelect={props.onSelect}
      dropdownItemWidth={props.width ?? 160}
      dropdownHeaderWidth={props.width ?? 160}
    ></LXSelector>
  );
};

export default LXTestCategorySelector;
